import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useQueryClient } from "@tanstack/react-query";
import useRequest from "@/lib/request/useRequest";
import { User } from "@/types/user";
import AddEditUserForm from "@/components/network/AddEditUserForm";

export const Route = createFileRoute("/dashboard/network/users/$userId")({
    component: RouteComponent,
});

function RouteComponent() {
    const { userId } = Route.useParams();
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { useGetRequest } = useRequest();

    const userQuery = useGetRequest<User>({
        url: `users/${userId}/`,
    });

    const handleClose = (shouldRefetch: boolean) => {
        if (shouldRefetch) {
            queryClient.invalidateQueries({ queryKey: ["users/"] });
        }
        navigate({
            to: "/dashboard/network/users",
            search: (prev) => prev,
        });
    };

    if (userQuery.isLoading || !userQuery.data) {
        return null;
    }

    return (
        <AddEditUserForm existingUser={userQuery.data} onClose={handleClose} />
    );
}
